export default {
  API_URL: {
    LOGIN: `/oauth/token`,
    USER: `${process.env.API_PREFIX}/user`,
    OAUTH: `${process.env.API_PREFIX}/oauth`,
    TMP_TORIHIKI: `${process.env.API_PREFIX}/tmp_torihiki`,
    CITY: `${process.env.API_PREFIX}/city`,
    ZIP: `${process.env.API_PREFIX}/zip_search`,
    IMAGES: `${process.env.API_PREFIX}/images`,
    IMAGES_ORDER: `${process.env.API_PREFIX}/images/order`,
    IMAGES_ORDER_OTHER: `${process.env.API_PREFIX}/images/order_other`,
    TOROKUBASHO: `${process.env.API_PREFIX}/new/torokubasyo`,
    AUCTION: `${process.env.API_PREFIX}/auction`,
    PLACE: `${process.env.API_PREFIX}/place`,
    OKINIIRI: `${process.env.API_PREFIX}/jyucyuokiniiri`,
    TEMPLATE: `${process.env.API_PREFIX}/jyucyutemplate`,
    JYUCYU: `${process.env.API_PREFIX}/jyucyu`,
    JYUCYU_SYARYO: `${process.env.API_PREFIX}/jyuchu_syaryo`,
    ACCOUNT: `${process.env.API_PREFIX}/account`,
    ACCOUNT_PW: `${process.env.API_PREFIX}/account/pw`,
    ACCOUNT_ACT_USER: `${process.env.API_PREFIX}/account/humuser`,
    REGISTER_VERIFY: `${process.env.API_PREFIX}/register/verify`,
    CHANGE_VERIFY: `${process.env.API_PREFIX}/change/verify`,
    TORIHIKI: `${process.env.API_PREFIX}/torihiki`,
    INQUIRY: `${process.env.API_PREFIX}/inquiry`,
    HISTORY: `${process.env.API_PREFIX}/history`,
    HOME_HISTORY: `${process.env.API_PREFIX}/home/history`,
    INFO: `${process.env.API_PREFIX}/info`,
    VALID_EMAIL: `${process.env.API_PREFIX}/account/valid_email`,
    PASSWORD: `${process.env.API_PREFIX}/password`,
    NUMBER_MEI: `${process.env.API_PREFIX}/humnumbermei`,
    VERSION: `${process.env.API_PREFIX}/version`,
    SYARYO_MAKER: `${process.env.API_PREFIX}/syaryomaker`,
    RIKUJI: `${process.env.API_PREFIX}/rikuji`,
    MAIL_TRIAL: `${process.env.API_PREFIX}/mail/trial`,
    MAIL_SIMPLE_TRIAL: `${process.env.API_PREFIX}/mail/simple_trial`,
    TRIAL: `${process.env.API_PREFIX}/trial`,
    TRIAL_ENTRY: `${process.env.API_PREFIX}/trial/entry`,
    TRIAL_ACT_USER: `${process.env.API_PREFIX}/trial/user`,
    NUMBERPLATE_OKINIIRI: `${process.env.API_PREFIX}/numberplate_okiniiri`,
    GROUP: `${process.env.API_PREFIX}/group`,
    INVOICE: `${process.env.API_PREFIX}/seikyu_okiniiri`,
    MITUMORI: `${process.env.API_PREFIX}/mitumori`,
    MITUMORI_RIREKI: `${process.env.API_PREFIX}/mitumori_rireki`,
    MITUMORI_OPTION: `${process.env.API_PREFIX}/mitumori_option`,
    RYOKIN: `${process.env.API_PREFIX}/ryokin`,
    VALID_MOJI: `/chk_kankyo_moji`,
    POS: `${process.env.API_PREFIX}/pos`,
    LOGGING: `${process.env.API_PREFIX}/loging`,
  },
  HAKOBO_API_BASE_URL: 'http://175.184.26.203/webapi/',
  USER: {
    ROLE: {
      ADMIN: 'admin',
      MEMBERS: 'members',
      ADMIN_MEMBER: 'admin_member', // 代理ログイン中
    },
    STATUS: {
      INITIAL: 'initial',
      ACTIVATED: 'activated',
      CHANGEID: 'changeid',
      RESTRICT: 'restrict',
    },
  },
  MOBILE: {
    PC: 'pc',
    TABLET: 'tablet',
    SP: 'sp',
  },
  TOROKU_AREA_TYPE: {
    AUCTION: 3,
    LANDMARK: 4,
    AREA: 5,
    HIKINO: 6,
    RIKUJI: 7,
  },
  RYOKIN_API_AREA_TYPE: {
    AUCTION: 3,
    LANDMARK: 4,
    AREA: 6,
    TOROKU: 7,
  },
  ORDER: {
    STATUS: {
      CHOSEI: 1,
      TEHAI: 2,
      HIKITORI: 3,
      NOSYA: 4,
      CANCEL: 9,
    },
  },
  YUSOKBN: {
    YARD: 'yard',
    KOJIN: 'kojin',
    CHUKO: 'chuko',
  },
  YUSOKBN_HCB: {
    KIGYO: 1,
    KOJIN: 2,
    AA: 3,
    MINATO: 4,
    YARD: 5,
    TENPO1: 6,
    TENPO2: 7,
    TENPO3: 8,
    RIKUJI: 9,
    FUKUOKA: 10,
    SYOHIN: 11,
    RS: 12,
    REAL: 13,
    SYUCCHO: 14,
    WOW: 15,
    YAKUSYO: 20,
  },
  // 「0：貿易ヤード」か「1：中継ヤード」か「3：顧客置き場」
  LANDMARK_YARD_VALUS: [0, 1, 3],

  // 自動車の車両タイプ区分
  syaryoTypeKbn: {
    normal: 1,
    kei: 4,
  },

  status: {
    irai: 1,
    taiou: 2,
    kaitou: 3,
    jyucyu: 4,
    mitoiawase: 5,
  },
}



// WEBPACK FOOTER //
// ./src/const.js